/**
 * Cio' che del rig PTZ serve da ENTRAMBE le parti del confine API.
 *
 * Il profilo completo (codifica degli assi, opcode di risposta, movimento
 * coordinato) vive nel server: sono misure fatte sul rig, e al browser non
 * servono. Il tetto di velocita' invece serve a tutti e due — il server per
 * limitare il byte Pelco, la UI per non offrire una posizione dello slider
 * che verrebbe respinta — e tenerlo scritto due volte significa che al primo
 * rig nuovo uno dei due resta indietro, in silenzio.
 */
/**
 * Massimo del byte di velocita' Pelco-D esposto all'operatore.
 *
 * 63 sul BIC-Inform e 20 su tutto il resto, e la differenza e' misurata: su
 * quel rig il byte vale ~0,034 °/s sul pan, quindi il tetto storico di 20 da'
 * 0,7 °/s — nove minuti per attraversare il pan, cioe' un asse che sembra
 * morto. Sui rig canonici 20 e' gia' svelto e alzarlo li' renderebbe il
 * comando manuale ingovernabile.
 */
export function maxManualSpeedFor(ptzModel) {
    return ptzModel === "bik-inform" ? 63 : 20;
}
/** Velocita' di default per la ronda, quando il cluster non ne ha una. Vale
 *  lo stesso ragionamento del tetto: 10 su un rig lento e' 0,34 °/s. */
export function defaultAutoSpeedFor(ptzModel) {
    return ptzModel === "bik-inform" ? 50 : 10;
}
/** I comandi direzionali, con i nomi che l'API accetta. */
export const PTZ_DIRECTIONS = [
    "up", "down", "left", "right",
    "upLeft", "upRight", "downLeft", "downRight",
];
/** Il rig ha un asse zoom? Sul BIC-Inform l'ottica e' fissa: mostrare i
 *  comandi zoom vorrebbe dire offrire bottoni che non fanno niente. */
export function hasZoomAxis(ptzModel) {
    return ptzModel !== "bik-inform";
}
//# sourceMappingURL=ptz.js.map